(function() {
    function setAttributes(el, attrs) {
        for (var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    var expandCounter = 0;
    var expandTables = document.querySelectorAll('[data-expand-table]');
    for (var i = 0; i < expandTables.length; i++) {
        var target = expandTables[i];
        var toggler = target.previousSibling;
        if (toggler.tagName === 'DIV' && toggler.className === 'section-heading') {
            setAttributes(target, {
                'id': 'expandTable' + expandCounter,
                'data-expand-table': expandCounter
            });
            setAttributes(toggler, {
                'role': 'button',
                'aria-controls': 'expandTable' + expandCounter,
                'aria-expanded': 'false',
                'tabindex': '0',
                'data-expandable': expandCounter,
                'class': 'section-heading section-heading-expand'
            });
            expandCounter++;
        }
    }

    var dataTogglers = document.querySelectorAll('[data-expandable]');
    var expandedClass = 'expanded';
    var expandableClass = 'elk-table-hidden';
    function toggleExpandable(toggler) {
        var togglerValue = toggler.getAttribute('data-expandable');
        var expandable = document.querySelector('[data-expand-table="' + togglerValue + '"]');
        expandable.classList.add(expandableClass);
        var doToggle = function() {
            if (expandable.classList.contains(expandableClass)) {
                toggler.classList.add(expandedClass);
                setAttributes(toggler, {
                    'aria-expanded': 'true'
                });
                expandable.classList.remove(expandableClass);
            } else {
                toggler.classList.remove(expandedClass);
                setAttributes(toggler, {
                    'aria-expanded': 'false'
                });
                expandable.classList.add(expandableClass);
            }
        };
        toggler.onclick = function() {
            doToggle();
        };
        toggler.onkeyup = function(e) {
            if (e.keyCode === 13) {
                doToggle();
            }
        };
    }

    for (var j = 0; j < dataTogglers.length; j++) {
        var toggler = dataTogglers[j];
        toggleExpandable(toggler);
    }
}());